/**
 * HomeRedirect.jsx — "/" ve "/Dashboard" için rol-duyarlı yönlendirme.
 * Personel (denetmen rolleri ve SuperAdmin) her zamanki gibi FdsSaha anasayfasına (/FdsSaha),
 * geri kalan herkes — firma, organizatör, rolü olmayan hesap — firma portalına (/Firma/Anasayfa).
 *
 * #307 (2026-10-10): karar artık sabit id listesiyle değil, backend'in personel kuralıyla
 * (firmaSessionService.isStaffAccount → groupInfo.staff) veriliyor. Organizatör rolleri (14-18)
 * eskiden /FdsSaha'ya gidip orada "yetkiniz yok" görüyordu; artık portala gidiyorlar.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { isStaffAccount } from "../../services/firmaSessionService";
// WAS (until #307): import { getCurrentPageAccessGroupId } from "../../Routes/pageAccess";

// WAS (until #307): const FIRMA_GROUP_IDS = [9, 19];

// #302: tab access follows the role whose PAGES this login gets (a new role: its template's).
// WAS:
// function getCurrentGroupId() {
//   try {
//     const groupInfo = JSON.parse(localStorage.getItem("groupInfo"));
//     return groupInfo?.id ?? groupInfo?.userGroupEntity?.id ?? null;
//   } catch {
//     return null;
//   }
// }
// WAS (until #307):
// function getCurrentGroupId() {
//   return getCurrentPageAccessGroupId();
// }

export default function HomeRedirect() {
  // WAS (until #307):
  // const groupId = getCurrentGroupId();
  // const target = FIRMA_GROUP_IDS.includes(groupId) ? "/Firma/Anasayfa" : "/FdsSaha";
  const target = isStaffAccount() ? "/FdsSaha" : "/Firma/Anasayfa";
  return <Navigate to={target} replace />;
}
